module.exports = __webpack_public_path__ + "static/media/appdevelopment.8674b353.gif";